module.exports = __webpack_public_path__ + "static/media/tuba.9a629bcc.wav";